/**
 * @constructor
 */
const Section = Class(
	/**
	 * @lends {Section#}
	 */
	{
		__NAME:'Section',
		/** @type {DR.ApiCall} */
		apiCall:null,
		cache:false,
		cacheBack:true,
		title:'',
		scrollTop:0,
		/** @type {Section} */
		prev:null,
		/** @type {*} */
		data:null,
		/** @type {Url} */
		url:null,
		meta: null,

		route: function() {
			if (this.url.current) {
				return new SectionUnknown;
			}
		},
		/** @type {Function} */
		onBeforeLeave:null,
		/** @type {Function} */
		onLeave:null,
		/** @type {Function} */
		onScroll:null,
		/** @type {Function} */
		onScrollUp:null,
		/** @type {Function} */
		onScrollDown:null,
		/** @type {Function} */
		onMouseWheel:null,
		/** @type {Function} */
		onMouseWheelUp:null,
		/** @type {Function} */
		onMouseWheelDown:null,
		/** @type {Function} */
		onBack:null,
		/** @type {Function} */
		onShow:null,
		/** @type {Function} */
		onResize:null,

		bodyClass: '',
		background: 0,
		backgroundVariant: 0,
		menuItem: null,

		_construct:function(){ // alias
			this.__construct();
		},

		__construct:function(){
			/** @member {Layout} */
			this.layout = new Layout;
			this.apiCall = new DR.ApiCall;
			this.apiCall.onClosed = this._onClosed;
			this.apiCall.onLoad = this.ready;
			this.meta = new Meta();
		},

		_onClosed:function(){
			var s = new SectionClosed;
			s.url = this.url;
			s.replace(this);
		},

		_onLeave:function(){
			if (this.meta) {
				this.meta.onLeave();
			}
			if( this.onLeave ){
				this.onLeave();
			}
		},

		_onResize:function(){
			if( this.onResize ){
				this.onResize();
			}
		},

		_onBeforeLeave:function(){
			if( this.onBeforeLeave ){
				return this.onBeforeLeave();
			}
		},

		routeNext:function(){
			var re = this;
			var tmp;
			while( tmp = re.route() ){
				re = tmp;
				re._copyVars(this);
			}
			if( tmp === false ){
				return false;
			}
			return re;
		},

		/**
		 * @param {Section} section
		 * @protected
		 */
		_copyVars:function(section){
			this.url = section.url;
			this.data = section.data;
			this._routePar = section._routePar;
			this.meta.setUrl(this.url.href);
		},

		_showCleanup:function(){
			try {
				var event;
				if( typeof window.Event === "function" ) {
					event = new Event('Cleanup');
					document.dispatchEvent(event);
				} else if( typeof window.Event === "object" ) { //IE
					event = document.createEvent( 'CustomEvent' );
					event.initCustomEvent( 'Cleanup', true, false, false);
					document.dispatchEvent(event);
				}
			} catch( error ) {
			}
		},

		/** @const */
		show:function(){
			if( Section.last ){
				if( Section.last instanceof SectionLoader ){
					this.prev = Section.last.prev;
				} else {
					Section.last._onLeave();
					this._showCleanup();
					this.prev = Section.last;
				}
			}
			Section.last = this;
			if( this.isReady ){
				this.ready();
				return;
			}
			D.loadingOverlay( document.getElementById('container'), { delay:true } );
			this.draw();
		},

		/**
		 * Call from php
		 */
		showRaw:function(){
			this.url = this.url || new Url;
			this.url.shift();
			var nextRoute = this.routeNext();
			// replace url from php
			nextRoute._routePar = nextRoute._routePar || {};
			nextRoute._routePar.popState = true;
			nextRoute.show();
		},

		draw:function(){
			this.ready();
		},

		ready:function(){
			if( this != Section.last ){
				return;
			}
			if( this._routePar && this._routePar.popState ){
				Section.replaceUrl( this.url.href );
			} else {
				Section.setUrl( this.url.href );
			}
			this._cacheAdd();
			var isReadyBefore = this.isReady;
			this.isReady = true;
			if( Section.last.prev ){
				removeClassName(document.body, Section.last.prev.bodyClass);
			}
			if( this.bodyClass ){
				addClassName(document.body, this.bodyClass);
			}
			removeClassName(document.body, 'menu-open');
			let menuItems = document.querySelectorAll('#main-menu > ul > li > a');
			for( let i = 0, l = menuItems.length; i < l; i++ ){
				if( menuItems[i].rel === this.menuItem ){
					addClassName(menuItems[i], 'active');
				}else{
					removeClassName(menuItems[i], 'active');
				}
			}
			if( this instanceof SectionUnknown ){
				Section.noIndex.append(getHeadElement());
			}else{
				Section.noIndex.remove();
			}
			this.layout.show();
			document.querySelectorAll('.menu-switch-lang-link').forEach(link => {
				link.href = D.url(this.url.href, link.getAttribute('lang'));
			});
			let scrollTop = 0;
			if( location.hash ){
				let hash = location.hash;
				if( hash.substr(0, 1) === '#' ){
					hash = hash.substr(1);
				}
				let hashEl = document.querySelector('[name="' + hash + '"]') || document.getElementById(hash);
				if( hashEl && hashEl.offsetTop ) {
					history.scrollRestoration = 'manual';
					scrollTop = hashEl.offsetTop - 24;
				}
			}
			if(isReadyBefore){
				$(window).scrollTop( Section.last.scrollTop );
			} else {
				$(window).scrollTop(scrollTop);
			}
			if (!this.meta.getTitle()) {
				this.meta.setTitle(this._title);
			}
			this.meta.render();
			D.gtagReset();
			if( this.onShow ){
				this.onShow();
			}
			if( this.onResize ) {
				this.onResize();
			}
			if( typeof window.Event === "function" ) {
				let event = new Event('SectionReady');
				document.dispatchEvent(event);
			}
		},

		back:function(){
			if( !this.prev ){
				return false;
			}
			this.prev.show();
			this.prev.onBack();
			return true;
		},

		replace:function(){
			this.show();
		},

		_cacheAdd:function(){
			Section._cache.del( this.url.href );
			Section._cache.set( this.url.href, this );
		},

		getCurrent:function(){
			this.layout.getCurrent();
		},

		referer:function(){
			if( this.prev ){
				return this.prev.url.href;
			}
			return document.referrer || location.referrer || '';
		},

		addRefererStats:function(){
			var mRef = new DR.stats.Referer;
			mRef.url = this.url.href;
			mRef.referer = this.referer();
			this.apiCall.addMethod(mRef);
		},

		addBodyClass( className ) {
			document.body.classList.add(className);
			let classNames = this.bodyClass.split(" ");
			if( classNames.indexOf(className) === -1 ) {
				classNames.push(className);
				this.bodyClass = classNames.join(" ");
			}
		},

		removeBodyClass( className ) {
			document.body.classList.remove(className);
			let classNames = this.bodyClass.split(" ");
			let index = classNames.indexOf(className);
			if( index !== -1 ) {
				classNames.splice(index, 1);
				this.bodyClass = classNames.join(" ");
			}
		},

		_fadeIn: [],

		fadeOnShow() {
			this._fadeIn = [];
			let faders = this.node.querySelectorAll('.fade');
			for (let i = 0; i < faders.length; i++) {
				const child = faders[i];
				child.classList.add('faded');
				this._fadeIn.push(child);
			}
			this._onScrollTo = setTimeout(this.onScroll, 100);
		},

		fadeOnScroll() {
			clearTimeout(this._onScrollTo);
			if (this._fadeIn.length) {
				for (let i = this._fadeIn.length - 1; i >= 0; i--) {
					const child = this._fadeIn[i];
					if (D.inScreenAny(child, 100)) {
						child.classList.remove('faded');
						child.classList.add('fade-in');
						this._fadeIn.splice(i, 1);
					}
				}
			}
		}
	}
);

Section.forceReload = false;

/**
 * @type {Section}
 * @static
 */
Section.last = null;

Section._href = Url.get();
Section._hrefOrig = Section._href; // nemainās ajax pieprasījumos

Section.env = 'www';

Section.noIndex = mkE({
	tag: 'meta',
	attr: {
		name: 'robots',
		content: 'noindex'
	}
});

/**
 * @type {D.SortedMap<Section>}
 */
Section._cache = new D.SortedMap;

Section.init = function(env){
	if( this.init.ok ){
		return;
	}
	if( env ){
		Section.env = env;
	}
	this.init.ok = true;
	if( 'onpopstate' in window ){
		$(window).on( 'popstate', D.closure( this, this._popstate ) );
	} else {
		this._hash = '#!' + location.pathname + ( location.search ? location.search : '' );
		setInterval( D.closure( this, this._checkHash ), 100 );
	}
	$(document).click( D.closure( this, Section._documentClick ) );
	$(window).scroll( D.closure( this, Section._onScroll ) );
	$(window).bind( 'mousewheel DOMMouseScroll', D.closure( this, Section._onMouseWheel ) );
	$(window).bind( 'beforeunload', D.closure( this, Section._onBeforeUnload ) );
	$(window).bind( 'resize', D.closure( this, Section._onResize ) );
	D.CSS.onResize();
	$(function(){
		if( Section.last ){
			return;
		}
		SectionHTML.get();
	});
	addClassName(document.documentElement, `os-${D.browser.OS.toLowerCase()}`);
};

Section._checkHash = function(){
	if( this._hash == location.hash ){
		return;
	}
	this._hash = location.hash;
	this._popstate();
};

Section._popstate = function(){
	if( this._href == Url.get() ){
		D.log('repeat');
		return;
	}
	this._href = Url.get();
	var hash = location.hash;
	if( hash[1] == '?' || hash[1] == '/' || hash == '#...' || hash == '#_' ){
		D.log('fix hash url');
		return;
	}
	Section._route( null, { popState:true } );
};

Section._onScroll = function(){
	if( !Section.last ){
		return;
	}
	if( Section.last.onScroll ){
		Section.last.onScroll();
	}
	var st = Section.last.scrollTop;
	Section.last.scrollTop = window.scrollY;
	if( Section.last.scrollTop - st > 0 ){
		if( Section.last.onScrollDown ){
			Section.last.onScrollDown();
		}
	} else if( Section.last.scrollTop - st < 0 ){
		if( Section.last.onScrollUp ){
			Section.last.onScrollUp();
		}
	}
};

Section._onMouseWheel = function(event){
	if( Section.last ){
		if( Section.last.onMouseWheel ){
			Section.last.onMouseWheel(event);
		}
		if( event.originalEvent.wheelDelta > 0 || event.originalEvent.detail < 0 ){
			if( Section.last.onMouseWheelUp ){
				Section.last.onMouseWheelUp(event);
			}
		} else {
			if( Section.last.onMouseWheelDown ){
				Section.last.onMouseWheelDown(event);
			}
		}
	}
};

Section._onBeforeUnload = function(){
	if( Section.last ){
		return Section.last._onLeave();
	}
};

Section._onResize = function(){
	D.CSS.onResize();
	if( Section.last ){
		return Section.last._onResize();
	}
};

Section.setUrl = function(href){
	if( href instanceof Url ){
		href = href.href;
	}
	Url.set(href);
	this._href = Url.get();
	//D.log('setUrl');
};

Section.replaceUrl = function(href){
	if( href instanceof Url ){
		href = href.href;
	}
	Url.replace(href);
	this._href = Url.get();
	//D.log('replaceUrl');
};

/**
 * @param {Event} e
 * @returns {*}
 * @private
 */
Section._documentClick = function(e){
	if( Section.forceReload ){
		return;
	}
	var a = e.target;
	if( ( D.browser.name != 'Explorer' || D.browser.version > 8 ) && e.which != 1 || e.ctrlKey ){
		return;
	}
	if( !a || !a.tagName ){
		return;
	}
	if( a.tagName.toUpperCase() != 'A' ){
		a = $(a).closest('a')[0];
		if(!a){
			return;
		}
	}
	if( a.tagName.toUpperCase() != 'A' ){
		return;
	}
	if( a.target || empty( a.href ) || a.href.indexOf('javascript:') != -1 || a.className.indexOf('noAjax') != -1 ){
		return;
	}
	if( a.hash && a.hash != '#' ){
		return;
	}
	if( a.hostname != location.hostname ){
		return;
	}
	var href = '';
	if( a.pathname[0] != '/' ){
		href = '/';
	}
	href += a.pathname;
	if( a.search ){
		href += a.search;
	}
	this.navigate(href);
	return false;
};

/**
 * @param {string|Url} href
 * @param {Object|null} par
 */
Section.navigate = function(href, par = null){
	var url = ( href instanceof  Url ? href : new Url(href) );
	this._route(url, par);
};

/**
 * @static
 * @param {Url} [url]
 * @param {Object} [par]
 */
Section._route = function( url, par ){
	if (Section.last) {
		if(Section.last._onBeforeLeave() === false) {
			return;
		}
	}
	par = par || {};
	url = url || new Url;
	this._href = url.href;
	this._hrefOrig = this._href;
	var cache = this._cache.get( url.href );
	if(cache){
		if( cache.cache || ( par.popState && this.last.prev === cache && cache.cacheBack ) ){ // back
			if( D.DEV ){
				D.log( 'Section back', cache );
			}
			this._cache.popLast();
			this.last._onLeave();
			if( this.last.bodyClass ) {
				removeClassName(document.body, this.last.bodyClass);
			}
			this.last = cache;
			cache._routePar = par;
			cache.ready();
			if( cache.onBack ){
				cache.onBack();
			}
			return;
		}
	}
	/** @type {Section} section */
	var section;
	var cur = url.shift();
	if( in_array(cur, D.LANGS) ){
		cur = url.shift();
	}
	var r = sectionRouting[cur];
	if(r){
		if( r === true ) {
			section = new SectionLoader(cur);
		} else if (r === false) {
			window.location = D.url('/');
			return;
		} else if( typeof r === 'function' ){
			section = r();
			if( section === false ) {
				return;
			}
		} else if (r === 'self') {
			window.location.href = this._href;
			return;
		} else if (r[0] === '/') {
			window.location = D.url(r);
			return;
		}
	}
	if(!section){
		section = new SectionUnknown();
	}
	section.url = url;
	section._routePar = par;
	section = section.routeNext();
	if( section === false ){
		return;
	}
	section.show();
};
// --- Section ---


/**
 * @class
 * @extends {Section}
 */
var SectionLoader = Class(
	/**
	 * @lends {SectionLoader#}
	 */
	{
		route: D.doNothing,

		/**
		 * @param {string} name
		 * @private
		 */
		__construct:function(name){
			this._name = name;
			this.env = D.ENV;
		},

		draw:function(){
			this._onload();
		},

		_onload:function(){
			/** @type {Section} section */
			var section;
			var nameParts = this._name.split('-');
			nameParts.forEach((part, index) => {
				nameParts[index] = ucfirst(part);
			});
			var name = 'Section' + nameParts.join('');
			try {
				section = eval(`new ${name}`);
			} catch(e) {
				D.console.error( 'Section not defined: ', name );
				return;
			}
			section._copyVars(this);
			section = section.routeNext();
			if( section === false ){
				return;
			}
			if( this != Section.last ){
				return;
			}
			section.show();
		}
	},
	Section
);

// +++ SectionUnknown +++
/**
 * @class
 * @extends {Section}
 */
var SectionUnknown = Class(
	/**
	 * @lends {SectionUnknown#}
	 */
	{
		bodyClass: 'small-nav error-page',

		route: D.doNothing,

		__construct:function(errorText){
			mkE({
				tag: 'div',
				className: 'page-error error-404 container',
				els: [
					{
						tag: 'h1',
						className: 'with-arrows',
						text: errorText || D.Lang.get('errors.404')
					}
				]
			}).append( this.layout.ct() );
		}
	},
	Section
);
// --- SectionUnknown ---

/**
 * @class
 * @extends {Section}
 */
var SectionClosed = Class(
	/**
	 * @lends {SectionClosed#}
	 */
	{
		__NAME:'SectionClosed',

		cacheBack:false,

		route: D.doNothing,

		__construct:function(){
			mkE( {
				tag:'center',
				els:[
					{
						tag:'img',
						src:D.PIMG + 'i/misc/closed_' + D.LANG + '.png',
						style:{
							height:'300px'
						}
					}
				]
			} ).append( this.layout.ct() );
			T.error( D.Lang.get('section_down') ).append( this.layout.ct() );
		}
	},
	Section
);

/**
 * @class
 * @extends {Section}
 */
var SectionHTML = Class(
	{
		__NAME:'SectionHTML',

		cacheBack:true,

		route: D.doNothing,

		__construct:function(){
			this.url = new Url;
			this.prev = Section.last;
			this.getCurrent();
			this.scrollTop = $(window).scrollTop();
			this.isReady = true;
			if( getHeadElement().getElementsByTagName('title')[0] ){
				this.title = getNodeText( getHeadElement().getElementsByTagName('title')[0] ) || document.title;
			} else {
				this.title = document.title;
			}
		}

	},
	Section
);

/**
 * @static
 */
SectionHTML.get = function(){
	var s = new SectionHTML;
	s._cacheAdd();
	s.prev = Section.last;
	Section.last = s;
};
